import { convertAmount } from "../../../utils/fxConvert.js";

/**
 * Aggregate only recorded recovery amounts. `annualIncome: null` means unknown,
 * not zero. Unknown or unconvertible rows keep the result explicitly partial.
 */
export function calculateSubleaseRecovery(records, headRentAmount, headRentCurrency, rates) {
  const rows = Array.isArray(records) ? records : [];
  const headRentUsd = headRentAmount == null
    ? null
    : convertAmount(headRentAmount, headRentCurrency, "USD", rates);
  let recordedIncomeCount = 0;
  let convertibleIncomeCount = 0;
  let knownIncomeUsd = 0;
  let unconvertibleIncomeCount = 0;

  for (const record of rows) {
    if (record?.annualIncome == null || record.annualIncome === "") continue;
    const amount = Number(record.annualIncome);
    if (!Number.isFinite(amount)) continue;
    recordedIncomeCount += 1;
    const converted = convertAmount(amount, String(record.currency || "").trim(), "USD", rates);
    if (converted == null || !Number.isFinite(converted)) {
      unconvertibleIncomeCount += 1;
      continue;
    }
    convertibleIncomeCount += 1;
    knownIncomeUsd += converted;
  }

  const hasUnknownIncome = recordedIncomeCount < rows.length;
  const isPartial = hasUnknownIncome || unconvertibleIncomeCount > 0;
  const incomeUsd = rows.length === 0 || convertibleIncomeCount === 0
    ? null
    : knownIncomeUsd;
  const canCalculateNet = headRentUsd != null
    && unconvertibleIncomeCount === 0
    && (rows.length === 0 || recordedIncomeCount > 0 || hasUnknownIncome);

  return {
    headRentUsd,
    incomeUsd,
    netExposureUsd: canCalculateNet ? headRentUsd - knownIncomeUsd : null,
    recordCount: rows.length,
    recordedIncomeCount,
    convertibleIncomeCount,
    unconvertibleIncomeCount,
    isPartial,
  };
}